import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select"]

    change() {
        const productId = this.selectTarget.value

        const wrapper = this.element.closest("[data-new-quotation-line]")
        const frame = wrapper?.querySelector("turbo-frame[id^='product_details_']")

        if (!productId || !frame) {
            if (frame) frame.innerHTML = ""
            return
        }

        const frameId = frame.id
        frame.src = `/products/${productId}/preview_details?frame_id=${frameId}`
    }
}